import { EOfficeType, Filters } from 'shared/types/filters';

export function hasTradeAreaOfficeType(filters: Filters): boolean {
  return filters.officeType.includes(EOfficeType.TradeArea);
}
